<template>
	<div class="mask">
		<Container v-show='!showPayCode'>
			<TopBar />
			<div class='paymentPage' v-if='desc'>
				<template v-if='desc.virtual_flag!=10'>
					<div class="top">
						<div class="logo">
							<div class="shadow">
								<img src="@/assets/order/paylogo2.png">
							</div>
						</div>
						<h2>結帳付款<br>Continue to Payment</h2>
						<div class="time">
							<b>剩餘時間(Time remaining):</b>
							<span>{{remaining.hour}}</span><i>:</i>
							<span>{{remaining.minute}}</span><i>:</i>
							<span>{{remaining.second}}</span>
						</div>
						<p>請確認配送地址無誤，如單一發貨訂單可於2小時內修改發貨地址。<br>
						Please confirm that the delivery address is correct. If it is single order, you are able to modify delivery address within 2 hours</p>
					</div>
				</template>
				<template v-else>
					<h2 class="mergeFree">支付合併發貨運費:HK${{desc.pay_fee.toFixed(2)}}</h2>
				</template>
				<div class="mid" v-if='desc'>
					<template v-if='desc.virtual_flag!=10'>
						<div class="orderNo">
							<b>NO:&nbsp;{{$route.query.os}}</b>
							<span>未付款(unpaid)</span>
						</div>
						<div class="info">
							<div class="item">
								<span>訂單來源(Order Source):香港訂購(Hong Kong Order)</span>
								<span>HK${{desc.pay_fee.toFixed(2)}}</span>
							</div>
							<div class="item">
								<span>訂單類型(Order Type):{{desc.catalog=='LRP'?'LRP':'Standard'}}</span>
								<span>PV:{{desc.total_pv.toFixed(2)}}</span>
							</div>
							<div class="item">
								<span>聯絡電話(Contact Number):{{passwordTel}}</span>
								<!-- <span>積分:{{desc.ar_value.toFixed(2)}}</span> -->
							</div>
						</div>

						<div class="info address" v-if='selectdesc&&selectdesc.code=="501"&&desc'>
							<div class="item">
								<span>收貨人(Consignee):</span>
								<span>{{selectdesc.name}} </span>
							</div>
							<div class="item">
								<span>聯絡方式(Contact Information):</span>
								<span>{{selectdesc.moblie_phone}}</span>
							</div>
							<div class="item">
								<span>詳細地址(Contact Address):</span>
								<span>{{selectdesc.province}} {{selectdesc.city}} {{selectdesc.street}} {{selectdesc.street2}}</span>
							</div>
							<div class="item">
								<span></span>
								<span @click="changeAddress" class="update">修改地址(Edit Address)</span>
							</div>
						</div>

						<div class="total">
							共{{productCount}}件商品({{productCount}} sets in total) 合計(Total)：HK${{desc.pay_fee.toFixed(2)}}&nbsp;(含運費 Delivery Fee Included HK${{desc.delivery_fee.toFixed(2)}})
						</div>
					</template>
					<div class="payList">
						<!-- 1微信 2支付宝 3聚合支付 4信用卡 6银联-->
						<div class="item" @click="payChannel=4">
							<div class="left">
								<img src="@/assets/order/visa1.jpg" style="padding: 12px 0;">
								<b>Visa</b>
							</div>
							<img v-if='payChannel==4' class="right" src="@/assets/order/hook.png">
						</div>
						<div class="item" @click="payChannel=5">
							<div class="left">
								<img src="@/assets/order/mastercard.jpg" style="padding: 9px 0;">
								<b>MasterCard</b>
							</div>
							<img v-if='payChannel==5' class="right" src="@/assets/order/hook.png">
						</div>
						<!-- <div class="item align" @click="payChannel=1">
							<div class="left">
								<img src="@/assets/order/nowechat.png">
								<b>WeChat</b>
							</div>
							<img v-if='payChannel==1' class="right" src="@/assets/order/hook.png">
						</div> -->
						<div class="item" @click="payChannel=6">
							<div class="left">
								<img src="@/assets/order/unionpay1.png" style="padding: 9px 0;">
								<b>UnionPay</b>
							</div>
							<img v-if='payChannel==6' class="right" src="@/assets/order/hook.png">
						</div>
						<!-- <div class="item" @click="payChannel=2">
							<div class="left">
								<img src="@/assets/order/alipay1.png" style="padding: 11px 0;">
								<b>AliPay</b>
							</div>
							<img v-if='payChannel==2' class="right" src="@/assets/order/hook.png">
						</div> -->
					</div>
                    <Checkbox style='margin: 10px;' v-model="single" /><span style="user-select: none;"><span style="color: #BC86C8;text-decoration: underline;cursor: pointer;" @click="policy = true">退款&退貨政策(Return & Refund Policy)</span></span>
				</div>
				<div class="foot">
					<Button size='large' :loading="!IsPay" :disabled='payChannel == 0 || countNum <=0' type="primary" shape="circle" @click="goPay">去支付(Process payment)</Button>
				</div>
			</div>
			<Modal v-model='policy' :mask-closable='false' width='850'>
				<div style="margin: 10px;">
					<ul>
						<li style="padding: 10px 0;">Once the BOGO order is confirmed, no refund nor exchange of items will be allowed , and no reward points for free items.</li>
						<li style="padding: 10px 0;">dōTERRA Hong Kong reserves the right of final decision and interpretation in case for any disputes.</li>
						<li style="padding: 10px 0;">BOGO訂單一經確定，不能修改或退貨，贈品不列入點數計算。</li>
						<li style="padding: 10px 0;">dōTERRA香港公司保留修改行使優惠及變更內容之最終決定權。</li>
					</ul>
				</div>
				<div slot='footer'>
					<Button type='primary' @click='policy = false'>確定 Confirm</Button>
				</div>
			</Modal>
		</Container>
		<transition name="fade">
			<div v-show='showAliPayCode' class="qrcode-bg">
				<div class='desc' v-if='desc'>
					<p>請您及時付款，以便訂單盡快處理！訂單號：{{$route.query.os}}</p>
					<p>Please pay timely! Order number: {{$route.query.os}}</p>
					<br>

					<p>請您在提交訂單後盡快完成支付, 否則訂單將{{remaining.hour}}:{{remaining.minute}}:{{remaining.second}}後取消。</p>
					<p>Please pay timely, time for payment left: {{remaining.hour}}:{{remaining.minute}}:{{remaining.second}}</p>
					<br>
					<p>應付金額:<b>{{desc.pay_fee.toFixed(2)}}</b>港元</p>

					<p>Total:<b>{{desc.pay_fee.toFixed(2)}}</b>Hong Kong dollar</p>
					
					<div class="banInfo">
						<Form :model="banInfo"  label-position="left">
							<FormItem label='信用卡銀行名稱 (Credit Card Bank Name)' prop='UserName' style="width: 30%;">
								<Input size='large' v-model='banInfo.UserName' placeholder='信用卡銀行名稱'></Input>
							</FormItem>
							<FormItem label='信用卡號碼 (Credit Card Number)' prop='Email' style="width: 30%;">
								<Input size='large' v-model='banInfo.Email' placeholder='信用卡號碼 Credit Card Number '></Input>
							</FormItem>
						</Form>
						<div style="width: 30%;text-align: center;">
							<Button type="primary" long @click="bankconfirm">確認</Button>
						</div>
					</div>
				</div>
				<div class="close">
					<svg width="60" height="60" style='cursor: pointer;' @click='colse'>
						<circle cx="30" cy="30" r="25" stroke="#636363" stroke-width="2" fill="none" />
						<line x1="22" y1="38" x2="38" y2="22" style="stroke:#636363;stroke-width:2" />
						<line x1="22" y1="22" x2="38" y2="38" style="stroke:#636363;stroke-width:2" />
					</svg>
				</div>
			</div>
		</transition>
		<transition name="fade">
			<div v-show='showPayCode' class="qrcode-bg">
				<div class='desc' v-if='desc'>
					<p>請您及時付款，以便訂單盡快處理！訂單號：{{$route.query.os}}</p>
					<p>Please pay timely! Order number: {{$route.query.os}}</p>
					<br>

					<p>請您在提交訂單後盡快完成支付, 否則訂單將{{remaining.hour}}:{{remaining.minute}}:{{remaining.second}}後取消。</p>
					<p>Please pay timely, time for payment left: {{remaining.hour}}:{{remaining.minute}}:{{remaining.second}}</p>
					<br>
					<p>應付金額:<b>{{desc.pay_fee.toFixed(2)}}</b>港元</p>

					<p>Total:<b>{{desc.pay_fee.toFixed(2)}}</b>Hong Kong dollar</p>
					<div class="qrcode" id='payQRCode'>
						<img :src='QRImg'>
						<div class="qrcode-desc">

							<template v-if='payChannel==1||payChannel==20'>
								<p>請使用微信掃一掃<b>(Use Wechat to scan)</b></p>
								<p>掃描二維碼支付<b>(Scan the code to pay)</b></p>
							</template>
							<template v-if='payChannel==3'>
								<p>請使用支付軟件掃一掃<b>(Use software to scan)</b></p>
								<p>掃描二維碼支付<b>(Scan the code to pay)</b></p>
							</template>
							<template v-if='payChannel==2'>
								<p>請使用支付寶掃一掃<b>(Use AliPay to scan)</b></p>
								<p>掃描二維碼支付<b>(Scan the code to pay)</b></p>
							</template>
						</div>
					</div>
					<div class='p-w-sidebar' :class="{alipay:payChannel==2,jhzf:payChannel==3}">

					</div>
				</div>
				<div class="close">
					<svg width="60" height="60" style='cursor: pointer;' @click='colse'>
						<circle cx="30" cy="30" r="25" stroke="#636363" stroke-width="2" fill="none" />
						<line x1="22" y1="38" x2="38" y2="22" style="stroke:#636363;stroke-width:2" />
						<line x1="22" y1="22" x2="38" y2="38" style="stroke:#636363;stroke-width:2" />
					</svg>
				</div>
			</div>
		</transition>
		<editAddressView title='修改收貨人' :editAddress='editAddress' :show='show' @confirm='asyncOK' @cancel='show=false' :loading='addressLoading'></editAddressView>
	</div>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { api_methods } from "@/service/loadData";
import editAddressView from "@/components/order/editAddressView";
import { QRCode } from "@/assets/js/qrcode.js";
import { baseUrl } from "@/config/env";
export default {
	data() {
		return {
			payChannel: 4, // 1微信 2支付宝 3聚合支付 4信用卡 6银联
			auto: false,
			result: false,
			IsPay: false,
			countNum: 0,

			desc: null,
			list: null,
			selectdesc: null,
			showAliPayCode: false,
			showPayCode: false,
			order_no: null,
			ajaxpay: null,
			forTime: [5000, 3000],
			forIndex: 0,
			QRImg: null,
			PayIn: false,
			editAddress: {
				id: 0,
				name: null,
				province_id: null,
				moblie_phone: null,
				city_id: null,
				county_id: null,
				town_id: null,
				street: null,
				street2: null,
				zip: null,
				email: null,
				wechatno: null,
				is_default: "0",
				tag_type: "0",
				address_type: "1",
			},
			show: false,
			addressLoading: false,
			banInfo:{
				hasPcNo:'0',
				Vipno:null,
				UserName:null,
				Email:null,
				MobilePhone:null,
				QuestionType:null,
				Question:null,
				QuestionImg:null,
				type:null,
				Isprocess:0,
			},
			single: false,
			policy: false,
		};
	},
	created() {
		this.$nextTick(function () {
			if (this.$route.query.orderno) {
				this.initData(this.$route.query.orderno, this.$route.query.os);
			}
		});
	},
	beforeDestroy: function () {
		clearInterval(this.timer);
		clearInterval(this.ajaxpay);
	},
	mounted() {},
	watch: {},
	mixins: [],
	components: {
		TopBar,
		editAddressView,
	},
	computed: {
		...mapGetters(["bogo_switch_tip", "getAccessToken", "getVipNo"]),
		...mapState({
			userInfo: (state) => state.common.wechatUserInfo.value,
		}),
		remaining: function () {
			let hour = parseInt(this.countNum / 3600);
			if (hour < 10) {
				hour = "0" + hour;
			}
			let minute = parseInt((this.countNum % 3600) / 60);
			if (minute < 10) {
				minute = "0" + minute;
			}
			let second = parseInt(this.countNum % 60);
			if (second < 10) {
				second = "0" + second;
			}
			return { hour, minute, second };
			//return hour + " : " + minute + " : " + second;
		},
		passwordTel: function () {
			if (
				this.selectdesc.moblie_phone &&
				this.selectdesc.moblie_phone.length >= 11
			) {
				return this.selectdesc.moblie_phone.replace(
					/(\d{3})\d{4}(\d{4})/,
					"$1****$2"
				);
			} else {
				return this.selectdesc.moblie_phone;
			}
		},
		productText: function () {
			if (this.list && this.list.length > 0) {
				return (
					"【doTERRA】" +
					this.list[0].name +
					(this.list[0].specification || "")
				);
			}
			return "暫無信息";
		},
		productCount: function () {
			if (this.list && this.list.length > 0) {
				return this.list.length;
			}
			return 0;
		},
	},

	methods: {
		...mapActions([
			"unionPayAction",
			"CheckPoint",
			"CheckAR",
			"CheckCart",
			"getOrderStatusAction",
			"changeOrderAddressAction",
			"postAddAddressAction",
			"getWechatUserInfoAction",
			"checkAccountBalanceAction",
		]),
		...mapMutations([
			"SAVE_PAYRECORD",
			"PAY_STATE",
			"SET_ORIGINA",
			"SET_ORDERSTATUS",
			"SAVE_USER_TIME",
		]),
		async initData(orderNo, os) {
			var yz = await api_methods.getProductOrder(
				this.getAccessToken,
				this.getUserId,
				orderNo,
				this.userInfo.binding.user_id,
				1,
				os
			);
			if (yz && yz.data && yz.response.code == "1") {
				var model = yz.data.value;
				this.desc = model.desc;
				this.list = model.product;
				this.selectdesc = model.delivery;
				if (
					(this.desc.order_status == "UnPay" ||
						this.desc.order_status == "Paying") &&
					this.desc.s > 0
				) {
					this.IsPay = true;
					this.countNum = this.desc.s;

					if (
						this.selectdesc.customer_type.toLowerCase() == "rt" &&
						this.desc.total_pv >= 100
					) {
						if (this.selectdesc.for_name) {
							this.SET_ORIGINA(10);
						} else {
							this.SET_ORIGINA(1);
						}
					} else {
						this.SET_ORIGINA(0);
					}

					this.remainingTime();
				}
			} else {
				this.$Modal.error({
					title: "錯誤",
					content: "訂單數據獲取異常",
					onOk: () => {
						this.$router.push("/home");
					},
				});
			}
		},
		remainingTime() {
			if (this.IsPay) {
				clearInterval(this.timer);
				this.timer = setInterval(() => {
					if (this.countNum <= 0) {
						this.showPayCode = false;
						clearInterval(this.timer);
						this.$Modal.warning({
							title: "超時",
							content: "支付超時",
							onOk: () => {
								this.$router.push("/order/orders");
							},
						});
					} else {
						this.countNum--;
					}
				}, 1000);
			}
		},
		shopCartList() {
			let newArr = new Array();
			Object.values(this.list).forEach((item) => {
				newArr.push({
					id: item.Id,
					name: item.name,
					packing_fee: item.packing_fee,
					price: item.price,
					pt: item.pt,
					pv: item.pv,
					point: item.Point,
					amount: item.amount, //現金支付金額
					ar_value: item.ar_value, //AR支付金額
					num: item.num, //數量(個數)，point支付和 amount支付總計個數
					sku_id: item.sku_id,
					sku: item.sku,
					selected: item.selected,
					spec_code: item.spec_code,
					product_flag: item.product_flag,
				});
			});
			return newArr;
		},
		confirm() {
			this.$router.push("/order/payresult");
		},
		async confrimPay() {
			if (!this.IsPay) {
				return false;
			}
			this.IsPay = false;
			if (!this.desc) {
				this.$Modal.error({
					title: "錯誤",
					content: "數據獲取異常",
				});
				return false;
			}
			// var result = await this.CheckPoint({
			// 	point: this.desc.total_change_point,
			// 	step: 3
			// });
			// if (result) {
			// 	this.$Modal.error({
			// 		title: "錯誤",
			// 		content: result
			// 	});
			// 	this.IsPay = true;
			// 	return false;
			// }
			// result = await this.CheckAR({ ar: this.desc.ar_value, step: 3 });
			// if (result) {
			// 	this.$Modal.error({
			// 		title: "錯誤",
			// 		content: result
			// 	});
			// 	this.IsPay = true;
			// 	return false;
			// }

			var msg = await this.checkAccountBalanceAction({
				ar: this.desc.ar_value,
				pt: this.desc.total_change_point,
				ab: this.desc.ab_value,
				step: 3,
				isBegin: true,
			});
			if (msg) {
				this.$Modal.error({
					title: "錯誤",
					content: msg,
				});
				this.IsPay = true;
				return false;
			}

			var ll = this.shopCartList();
			var store_id = null;
			if (this.selectdesc) {
				store_id = this.selectdesc.code || null;
			} else {
				store_id = this.desc.store_id;
			}
			if (this.desc.virtual_flag != 10) {
				var result = await this.CheckCart({
					ll,
					store_id,
					orderNo: this.$route.query.os,
					step: 3,
				});
				if (result) {
					this.$Modal.error({
						title: "錯誤",
						content: result,
					});
					this.IsPay = true;
					return false;
				}
			}

			var pc = '';
			if(this.payChannel == 4){
				pc = 'Visa';
			}else if (this.payChannel == 5) {
				pc = 'Mastercard';
			}else if (this.payChannel == 1) {
				pc = 'WechatPay';
			}else if (this.payChannel == 2) {
				pc = 'AliPay';
			}else if (this.payChannel == 6) {
				pc = 'UnionPay';
			}

			var res = await api_methods.payOrder(
				this.getAccessToken,
				this.getUserId,
				this.$route.query.orderno,
				pc,
				this.$route.query.os
			);

			if (res && res.response && res.response.code == "1") {
				if (res.data.value.code == "1") {
					var obj = res.data.value;
					this.order_no = obj.orderno;
					this.SET_ORDERSTATUS(null);
					this.SAVE_PAYRECORD({
						OrderNo: obj.orderno,
						Amount: obj.amount,
						Body: obj.order_body,
						Openid: obj.openid,
						ARValue: obj.arvalue,
						payChannel: this.payChannel,
					});
					var Amount = Math.round(obj.amount * 100, 2);
					var name = this.selectdesc.for_name;
					if (Amount > 0) {
						Amount = 1; //模擬字符1分錢；
						this.IsPay = true;
						return true;
						// if (this.payWay == 2) {

						// }else {
						//     //信用支付
						//     this.$Modal.error({
						//         title:'支付錯誤',
						//         content:'功能正在開發中，請選擇微信支付'
						//     });
						//     this.IsPay = true;
						//     return false
						//     //this.$router.push('/order/paymentconfirm?type=yes&orderno='+obj.orderno);
						// }

						//this.$router.push('/doTERRA/index.html#/order/paymentconfirm?type=yes&orderno='+obj.orderno);
					} else {
						//直接付款成功
						//直接告訴用戶付款完成，不能在這裏調用，也不能配置URL，這樣存在安全風險。 （需要在    og011 中直接完成）
						this.IsPay = true;
						this.$router.push({
							path: "/order/payresult",
							query: {
								type: "yes",
								orderno: this.$route.query.orderno,
								os: this.$route.query.os,
							},
						});
						return false;
					}
				} else if (res.response.errorCode == "0100") {
					this.$Modal.error({
						title: "錯誤 (error)",
						content: res.data.value.message,
						loading: true,
						okText: "重新加載",
						onOk: async () => {
							await this.getWechatUserInfoAction();
							this.$Modal.remove();
						},
					});
					this.IsPay = true;
					return false;
				} else {
					this.$Modal.error({
						title: "支付異常",
						content: res.data.value.message,
					});
					this.IsPay = true;
					return false;
				}
			} else {
				this.$Modal.error({
					title: "支付異常",
					content: "支付發生異常,請重新嘗試",
				});
				this.IsPay = true;
				return false;
			}
			return true;
		},
		async goPay() {
			if(!this.single){
				this.$Modal.warning({
					title: "提示",
					content: `請點擊勾選退款&退貨政策<br>Please check the Return & Refund Policy`,
				});
				return;
			}
			let res = await this.confrimPay();
			console.log(res);
			if (!res) return;
			// 1微信 2支付宝 3聚合支付 4信用卡5信用卡 6银联
			if (this.payChannel == 1) {
				location = `${baseUrl}/Public/Pay/HKPay/CybsPagePay.aspx?order_no=${this.order_no}&pc_no=${this.getVipNo}&paychannel=wechatpay&card_type=`;
			} else if (this.payChannel == 6) {
				location = `${baseUrl}/Public/Pay/HKPay/CybsPagePay.aspx?order_no=${this.order_no}&pc_no=${this.getVipNo}&paychannel=unionpay&card_type=`;
			} else if (this.payChannel == 4) {
				location = `${baseUrl}/Public/Pay/HKPay/CybsPagePay.aspx?order_no=${this.order_no}&pc_no=${this.getVipNo}&paychannel=creditcardpay&card_type=001`;
			} else if (this.payChannel == 5) {
				location = `${baseUrl}/Public/Pay/HKPay/CybsPagePay.aspx?order_no=${this.order_no}&pc_no=${this.getVipNo}&paychannel=creditcardpay&card_type=002`;
			} else if (this.payChannel == 2) {
				location = `${baseUrl}/Public/Pay/HKPay/CybsPagePay.aspx?order_no=${this.order_no}&pc_no=${this.getVipNo}&paychannel=alipay&card_type=`;
			} else {
				var app = "sftogether";
				if (this.payChannel == 2) {
					app = "sfwechat";
				} else if (this.payChannel == 1) {
					app = "sfalipay";
				} else if (this.payChannel == 20) {
					app = "wechat";
				}
				//if(this.payChannel)
				let response = await this.unionPayAction({
					order_no: this.$route.query.orderno,
					orderno_tip: this.$route.query.os,
					pc_no: this.getVipNo,
					app,
				});
				if (response && response.Status == 1 && response.QRCode) {
					let el = document.createElement("div");
					var qrcode = new QRCode(el, {
						text: response.QRCode,
						width: 300,
						height: 300,
						colorDark: "#000000",
						colorLight: "#ffffff",
						correctLevel: QRCode.CorrectLevel.H,
					});

					let desEl = document.getElementById("payQRCode");

					desEl.replaceChild(
						qrcode._el.children[1],
						desEl.firstChild
					);
					desEl.firstChild.style.width = "90%";
					desEl.firstChild.style.margin = "0 auto";

					this.showPayCode = true;
					this.PayIn = true;
					this.beginfor(this.order_no);
				} else if (response && !response.QRCode) {
					var params = {
						charset: response.charset,
						signType: response.signType,
						//"data":this.HTMLDecode(response.data),
						data: response.data,
						sign: response.sign,
						extend: response.extend,
					};
					this.standardPost(response.serverUrl, params);
				} else if (response) {
					this.$Modal.error({
						title: "支付失敗",
						content: response.Message,
					});
				} else {
					this.$Modal.error({
						title: "支付失敗",
						content: "支付發生異常,請重新嘗試",
					});
				}
			}
		},
		bankconfirm() {
		},
		colse() {
			this.showPayCode = false;
			this.showAliPayCode = false;
			clearInterval(this.ajaxpay);
		},
		beginfor(orderNo) {
			var vm = this;
			var s =
				this.forTime[this.forIndex] ||
				this.forTime[this.forTime.length - 1];
			clearInterval(this.ajaxpay);
			this.ajaxpay = setInterval(function () {
				vm.forOrderStatus(orderNo);
			}, s); // 每間隔一秒執行一次
		},
		async forOrderStatus(orderNo) {
			let res = await this.getOrderStatusAction(orderNo);
			console.log("查詢支付結果");
			if (res) {
				if (res.PayStatus == "1") {
					clearInterval(this.ajaxpay);
					this.SAVE_USER_TIME();
					//this.SET_ORDERSTATUS(res);
					this.$router.push({
						path: "/order/payresult",
						query: {
							type: "yes",
							orderno: this.$route.query.orderno,
							os: this.$route.query.os,
						},
					});
				}
			}
			this.forIndex++;
			this.beginfor(orderNo);
		},
		async changeAddress() {
			var delivery = this.selectdesc;
			this.editAddress = {
				id: 0,
				orderNo: this.$route.query.os,
				name: this.selectdesc.name,
				province_id: parseInt(this.selectdesc.province_id),
				city_id: parseInt(this.selectdesc.city_id),
				county_id: parseInt(this.selectdesc.county_id),
				town_id: parseInt(this.selectdesc.town_id),
				street: this.selectdesc.street,
				street2: this.selectdesc.street2,
				zip: this.selectdesc.zip,
				email: this.selectdesc.email,
				wechatno: this.selectdesc.wechatno,
				moblie_phone: this.selectdesc.moblie_phone,
				address_type: 2,
				tag_type: "",
				is_default: false,
				whetherAddress: false,
			};
			this.show = true;
		},
		async asyncOK(address) {
			this.addressLoading = true;
			var obj = {
				Id: address.id,
				Name: address.name,
				MobliePhone: address.moblie_phone,
				Province: address.province_id,
				City: address.city_id,
				County: address.county_id,
				Town: address.town_id,
				Street: address.street,
				Street2: address.street2,
				Zip: address.zip,
				Email: address.email,
				WechatNo: address.wechatno,
				AddressType: address.address_type,
				Tags: address.tag_type,
				IsDefault: address.is_default ? 1 : 0,
				CustomerId: this.userInfo.binding.user_id,
				orderNo: this.$route.query.os,
				Remark: "",
			};
			let response = await this.changeOrderAddressAction(obj);
			if (response > 0) {
				if (address.whetherAddress) {
					await this.postAddAddressAction(obj);
					await this.getWechatUserInfoAction();
				}
				this.$Message.success("地址修改成功");
				await this.initData(
					this.$route.query.orderno,
					this.$route.query.os
				);
			} else {
				let message = "";
				if (response == -1) {
					message =
						"訂單不存在或者訂單已經發貨或者已經取消不可以修改";
				} else if (response == -2) {
					message = "訂單正在處理中，請稍後修改";
				} else {
					message = "地址修改失敗";
				}
				this.$Message.error(message);
			}
			this.show = false;
			this.addressLoading = false;
		},
	},
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.paymentPage {
	width: 70.03vw;
	margin: 40px auto;
	margin-bottom: 30px;
	overflow: hidden;
}
.top {
	text-align: center;
	margin: auto;
	margin-top: 30px;
	.logo {
		margin: auto;
		width: 150px;
		border-radius: 200px;
		box-shadow: 1px 1px 20px #dddddd8c;
		height: 150px;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		.shadow{
			font-size: 0;
			img {
				width: 100px;
			}
		}
	}
	h2 {
		margin-top: 20px;
	}
	.time {
		margin-top: 20px;
		span {
			padding: 5px;
			background-color: $theme-color;
			display: inline-block;
			color: white;
		}
		i {
			font-style: normal;
			@include fontSize($font-size-13);
			margin: 0 5px;
		}
		b {
			font-weight: 500;
			margin-right: 5px;
		}
	}
	p {
		margin-top: 20px;
	}
}
.mid {
	width: 40.03vw;
	margin: auto;
	margin-top: 20px;
	.orderNo {
		border-bottom: 1px solid #dedede;
		height: 30px;
		b {
			float: left;
		}
		span {
			float: right;
			padding: 1px 10px;
			border: 1px solid $theme-color;
			color: $theme-color;
			@include fontSize($font-size-13);
			border-radius: 10px;
		}
	}
	.info {
		border-bottom: 1px solid #dedede;
		.item {
			height: 30px;
			line-height: 30px;
			overflow: hidden;
			span:nth-of-type(2) {
				color: $theme-color;
				float: right;
			}
		}
		&.address {
			span:nth-of-type(2) {
				color: #636363;
				float: right;
			}
			span.update {
				color: $theme-color;
				font-weight: 800;
				cursor: pointer;
			}
		}
	}
	.total {
		margin-top: 10px;
		font-weight: 500;
		margin-bottom: 10px;
	}
	.payList {
		.item {
			cursor: pointer;
			padding: 10px 0;
			//clear: both;
			overflow: hidden;
			border-bottom: 1px solid #dedede;

			.left {
				float: left;
				img {
					width: 50px;
				}
				b {
					padding-left: 10px;
					position: relative;
					top: -15px;
				}
			}
			.right {
				float: right;
				width: 25px;
				margin-top: 10px;
			}
		}
	}
}
.foot {
	margin-top: 20px;
	text-align: center;
	button {
		padding: 0 35px;
	}
}

.qrcode-bg {
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: white;
	overflow: scroll;
	z-index: 2000;
	//   overflow: hidden;
	.desc {
		display: block;
		position: absolute;
		top: 30px;
		left: 5%;
		width: 95%;
		overflow: hidden;
		//left: calc(45vw - 150px);
		& > p {
			@include fontSize($font-size-18);
			font-weight: bold;
			color: #636363;
			text-rendering: optimizeSpeed;
			font-style: normal;
			b {
				@include fontSize($font-size-30);
				vertical-align: middle;
				color: #bc86c8;
				margin: 0 10px;
				position: relative;
				top: -5px;
			}
		}
	}
	.qrcode {
		margin-top: 20px;
		display: block;
		// position: absolute;
		width: 300px;
		// height: 300px;
		float: left;
		// top: calc(40vh - 50px);
		// left: calc(50vw - 400px);
		.qrcode-desc {
			width: 100%;
			// height: 58px;
			background-color: #bc86c8;
			line-height: 22px;
			color: white;
			text-align: center;
			font-weight: 700;
			@include fontSize($font-size-15);
			line-height: 27px;
			margin-top: 20px;
			b {
				@include fontSize($font-size-13);
				font-weight: 500;
				// display: block;
			}
		}
	}
	.qrimg {
		width: 90%;
		margin: auto;
	}
	.close {
		position: fixed;
		top: calc(3vh - 0px);
		//left: calc(50vw - 30px);
		right: 30px;
	}
}
.p-w-sidebar {
	float: left;
	width: 379px;
	height: 421px;
	padding-left: 50px;
	// margin-top: -20px;
	background: url(http://cdn.doterra.cn/skin/frontend/rwd/dtr/images/phone-bg.png)
		50px 0 no-repeat;
	&.alipay {
		background: url(../../../assets/order/phone-alipay-bg.png) 50px 0
			no-repeat;
	}
	&.jhzf {
		background: url(../../../assets/order/phone-jhzf-bg.png) 50px 0
			no-repeat;
	}
}
.mergeFree {
	text-align: center;
	@include fontSize($font-size-16);
	color: $theme-color;
}

.banInfo{
	padding-top: 20px;
}

@media (max-width: 768px) {
	.paymentPage {
		width: 90%;
		font-size: 0.65rem;
	}
	.mid {
		width: 100%;
	}
	.qrcode-bg .desc > p {
		b {
			font-size: 0.7rem;
		}
		font-size: 0.65rem;
	}
	.qrcode-bg .close {
		right: 0;
	}
	.qrcode-bg .qrcode .qrcode-desc {
		font-size: 0.55rem;
		b {
			font-size: 0.65rem;
		}
	}
}
</style>